export const REQUEST_CD_TYPES = {
  DEPLOYMENT_DIVISION_TYPE: "deployment_division_type",
};

export enum DPLY_IMPL_TYPE {
  IMMEDIATELY_DEPLOY = "1",
  SCHEDULE_DEPLOY = "2",
}

export const DEFAULT_DPLYMNT_TIME = "00:00";

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);

export const createDplymntDtime = (
  dplymntDate: string,
  dplymntTime: string,
) => {
  if (!dplymntDate || !dplymntTime) return "";
  return dplymntDate + " " + dplymntTime + ":00.000";
};
